import { render, staticRenderFns } from "./OrkProductCart.html?vue&type=template&id=7c8b6b17&scoped=true&"
import script from "./OrkProductCart.vue?vue&type=script&lang=js&"
export * from "./OrkProductCart.vue?vue&type=script&lang=js&"
import style0 from "./OrkProductCart.scss?vue&type=style&index=0&id=7c8b6b17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8b6b17",
  null
  
)

export default component.exports